module.exports = __webpack_public_path__ + "static/other_secondary_endpoint_chart-19af9a957ba2bd7dce9622b820bf78cb.png";